<template>
  <div class="content__box">
    <h2 class="content__box--heading" v-html="content.name">
    </h2>
    <div class="content__box--content" v-html="content.description"></div>
    <p class="content__box--email" v-if="content.email">
      e-mail : <span>{{ content.email }}</span>
    </p>
    <a target="_blank" :href="traceRoute">
      <button class="base-button">
        <img width="19" height="19" :src="require('../assets/show-route.png')"
          :alt="translateShowRouteIcon()" loading="lazy" />
        {{ translateShowRoute() }}
      </button>
    </a>
  </div>
</template>

<script>
import { ref } from "vue";
export default {
  props: {
    content: Object,
  },
  setup(props) {
    const contentAddress = ref("");
    const traceRoute = ref(`https://www.google.com/maps/dir/?api=1&destination=${props.content.position.lat},${props.content.position.lng}`);
    const loadingAddresss = ref(false);
    const getAddressRefetchCount = ref(0);
    function translateShowRoute() {
      return window.Drupal.t("Show route");
    }
    function translateShowRouteIcon() {
      return window.Drupal.t("Show route icon");
    }
    return {
      contentAddress,
      loadingAddresss,
      traceRoute,
      translateShowRoute,
      translateShowRouteIcon,
      getAddressRefetchCount
    };
  },
};
</script>